import React, {useEffect, useState} from "react";
import removeFromCart from "../../../cookieStorage/removeFromCart";
import {useDispatch, useSelector} from "react-redux";
import {fetchColorById} from "../../../reduxLib/colorsLib";


function ShopingProductCard(props) {

    const dispatch = useDispatch();
    const limit = 5;              // ← ό,τι θες (από API αύριο)
    const [qty1, setQty1] = useState(() => {
        const q = Number(props.quantity ?? 1);
        return Math.min(limit, Math.max(0, q));
    });

    const inc = () => {
        setQty1(q => {
            const newQty = Math.min(limit, q + 1);
            props.onQuantityChange?.(props.id, newQty);
            return newQty;
        });
    };

    const dec = () => {
        setQty1(q => {
            const newQty = Math.max(0, q - 1);
            props.onQuantityChange?.(props.id, newQty);
            return newQty;
        });
    };

    const [selectedColor, setSelectedColor] = useState(null);
    const colorsL=useSelector((state) => state.colorreducer.selectedColor);
    const state=useSelector((state) => state.colorreducer.status);

    useEffect(() => {


            dispatch(fetchColorById(props.color)).then((action) => {
                // Once the action is fulfilled, set the eventprofile state
                if (action.payload) {
                    setSelectedColor(action.payload);
                    console.log(selectedColor);
                }

            });


    }, [props.color]);


    return (
        <div id={`cart-item-${props.indexn}`}
             className="p-6 border-b border-gray-100 hover:bg-gray-50 transition-colors">
            <div className="flex items-center space-x-6">
                <div className="h-32 w-32 overflow-hidden rounded-lg flex-shrink-0">
                    <img className="w-full h-full object-cover"
                         src={props.image}
                         alt={props.name}/>
                </div>
                <div className="flex-grow">
                    <h3 className="text-xl font-serif font-semibold text-gray-800 mb-2">{props.name}</h3>
                    <p className="text-gray-600 mb-3">{props.description}</p>
                    <div className="flex items-center space-x-4">
                        <span className="text-sm text-gray-500">Color: {selectedColor?.colorName}</span>
                        {/*<span className="text-sm text-gray-500">Size: Large</span>*/}
                    </div>
                </div>
                <div className="flex flex-col items-end space-y-4">
                    <button onClick={()=>{
                        removeFromCart(props.id);
                        props.onDelete?.(props.id);
                    }} className="text-gray-400 hover:text-red-500 transition-colors">
                        <i className="fas fa-trash"></i>
                    </button>
                    <div
                        className="flex items-center space-x-3 border border-gray-200 rounded-lg">
                        <button
                            type="button"
                            onClick={dec}
                            disabled={qty1 === 0}
                            className="px-3 py-2 transition-colors
               disabled:opacity-40 disabled:cursor-not-allowed
               hover:bg-gray-100"
                        >
                            <i className="fas fa-minus text-sm text-gray-600"></i>
                        </button>

                        <span className="px-4 font-medium text-gray-800">
    {qty1}
  </span>

                        <button
                            type="button"
                            onClick={inc}
                            disabled={qty1 === limit}
                            className="px-3 py-2 transition-colors
               disabled:opacity-40 disabled:cursor-not-allowed
               hover:bg-gray-100"
                        >
                            <i className="fas fa-plus text-sm text-gray-600"></i>
                        </button>
                    </div>
                    <span className="text-2xl font-bold text-brand-green">€{props.price}</span>
                </div>
            </div>
        </div>
    );
}
export default ShopingProductCard;